'use client';

import { useState } from 'react';

import styles from './BackgroundVideo.module.css';
import {
  useBackgroundVideoGate,
  useDeferredPlayerMount,
  type BackgroundVideoPoster as BackgroundVideoPosterConfig,
} from './backgroundVideo.shared';
import { BackgroundVideoPoster } from './BackgroundVideoPoster';

type BackgroundVideoYouTubeProps = {
  videoId: string;
  poster: BackgroundVideoPosterConfig;
  className?: string;
};

/**
 * YouTube background embed: poster is LCP-safe; iframe loads only in-view +
 * idle. Skipped under reduced-motion or save-data preferences.
 */
export function BackgroundVideoYouTube({ videoId, poster, className }: BackgroundVideoYouTubeProps) {
  const { ref, shouldPlay } = useBackgroundVideoGate();
  const playerReady = useDeferredPlayerMount(shouldPlay);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const embedSrc = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&playsinline=1&rel=0&modestbranding=1&enablejsapi=0`;

  return (
    <div ref={ref} className={[styles.root, className].filter(Boolean).join(' ')}>
      <BackgroundVideoPoster {...poster} hidden={iframeLoaded && shouldPlay} />
      {playerReady ? (
        <iframe
          className={styles.iframe}
          src={embedSrc}
          title=""
          aria-hidden="true"
          tabIndex={-1}
          allow="autoplay; encrypted-media"
          onLoad={() => setIframeLoaded(true)}
        />
      ) : null}
    </div>
  );
}
